import utils from '../utils'
import api from '../apis'

export default {
    state: {
        viaLists: [],
    },
    getters: {
        getViaInfosStore() {
            return JSON.parse(localStorage.getItem('ViaInfos'));
        }
    },
    mutations: {
        setViaInfos(state, ViaInfos) {
            state = localStorage.setItem('ViaInfos', JSON.stringify(ViaInfos));
        },
        removeViaInfos() {
            localStorage.removeItem('ViaInfos');
        }
    },
    actions: {
        insertViaInfos({
            commit
        }, ViaInfos) {
            commit('setViaInfos', ViaInfos)
        },
        deleteViaInfos({
            commit
        }) {
            commit('removeViaInfos')
        }
    }
}



// WEBPACK FOOTER //
// ./src/store/viaList.js